import { render, staticRenderFns } from "./CorrelationListItem.vue?vue&type=template&id=6c47565a&scoped=true&"
import script from "./CorrelationListItem.vue?vue&type=script&lang=ts&"
export * from "./CorrelationListItem.vue?vue&type=script&lang=ts&"
import style0 from "./CorrelationListItem.vue?vue&type=style&index=0&id=6c47565a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c47565a",
  null
  
)

export default component.exports